"use client";

import Link from "next/link";

import { useSettings } from "@/components/providers/SiteDataProvider";
import { Icon } from "@/components/ui/icons";
import { formatAddress, formatPhoneNumber, formatTel } from "@/utils/format";

export function ContactInfo() {
  const settings = useSettings();
  const contact = settings?.contact;

  if (!contact) return null;

  const iconContainerClasses =
    "bg-emerald-darkest flex h-10 w-10 shrink-0 items-center justify-center rounded-lg";
  const iconClasses = "text-emerald-600";
  const linkClasses = "text-lg font-medium text-white transition-colors hover:text-emerald-400";
  const textClasses = "text-lg font-medium text-white";

  return (
    <div className="flex flex-col gap-6">
      {contact.phone && (
        <div className="flex items-center gap-4">
          <div className={iconContainerClasses}>
            <Icon name="Phone" size={32} className={iconClasses} />
          </div>
          <Link href={formatTel(contact.phone) ?? "#"} className={linkClasses}>
            {formatPhoneNumber(contact.phone)}
          </Link>
        </div>
      )}

      {contact.email && (
        <div className="flex items-center gap-4">
          <div className={iconContainerClasses}>
            <Icon name="Email" size={32} className={iconClasses} />
          </div>
          <Link href={`mailto:${contact.email}`} className={linkClasses}>
            {contact.email}
          </Link>
        </div>
      )}

      {contact.address && (
        <div className="flex items-center gap-4">
          <div className={iconContainerClasses}>
            <Icon name="Location" size={32} className={iconClasses} />
          </div>
          <div className="flex flex-col">
            {formatAddress(contact.address).map((line, index) => (
              <p key={index} className={textClasses}>
                {line}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
